/**
 * patrol-building-search-view.js
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import PatrolArrestsBites from '../../helpers/patrol-arrests-bites-view';


export default function PatrolBuildingSearchView(props) {
  const { 
    deployment,
    record,
  } = props;
  const { t } = useTranslation('deploymentEdit');


  return (
    <>      
      <IconSection iconName='patrol-building-search'>

        {/* building types */}
        <InfoRow 
          title={t('buildingSearch.types.viewLabel')} 
          text={record.buildingSearch.types.map(type => type.customOtherName || type.name).join(', ')} 
        />

        {/* total area */}
        {record.buildingSearch.areaSize !== null && record.buildingSearch.areaSize > 0 && 
        <InfoRow 
          title={t('buildingSearch.areaSize.viewLabel')} 
          text={`${record.buildingSearch.areaSize} ${record.buildingSearch.areaSizeUnit?.name || ''}`} 
        />}

        {/* search duration */}
        <InfoRow
          title={t('buildingSearch.searchDuration.viewLabel')}
          text={`${record.buildingSearch.searchDurationMinutes} ${t('buildingSearch.searchDuration.timeUnit')}`}
        />

        {/* track age */}
        <InfoRow
          title={t('buildingSearch.trackAge.viewLabel')}
          text={`${record.buildingSearch.trackAgeMinutes} ${t('buildingSearch.trackAge.timeUnit')}`}
          dataTestId='info-row-track-age'
        />

      </IconSection>

      <PatrolArrestsBites 
        deployment={deployment}
        record={record}
      />
    </>
  );
}